const yup = require('yup')
const { requiredFields, labelify } = require('./helpers')
const { uploadSchema } = require('./cloudinary-schema')
const timeField = require('./fields/time-field')

const mealTypeSchema = yup.object().shape({
  _id: yup.string(),
  labelId: yup.mixed(),
  start: timeField(),
  end: timeField(),
})

const shape = labelify({
  name: yup.string().default(''),
  details: yup.string().default(''),
  mealTypesOverride: yup.mixed().default({}),
  image: uploadSchema,
  externalId: yup.number().nullable(),
  createdAt: yup.date(),
  updatedAt: yup.date(),
  createdBy: yup.mixed(),
  updatedBy: yup.mixed(),
})

const mealLocationSchemaPartial = yup.object().shape(shape)
const mealLocationSchema = mealLocationSchemaPartial.shape(requiredFields(['name'])(shape))

const mealLocationFormSchema = mealLocationSchema.shape({
  mealTypesOverride: yup.mixed().default({}),
})

module.exports = { mealLocationFormSchema, mealLocationSchema, mealTypeSchema, mealLocationSchemaPartial }
